<div class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
    </div>

    <span class="page-title">Dealers OTA Management</span>
  </div>

  @if (DealersOTAView) {
    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">Dealers OTA List</h6>
        <div class="component-actions">
          <app-common-search
            (searchSubmit)="onSearchInputChange($event)"
          ></app-common-search>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th style="width: 200px; white-space: nowrap">Dealer Name</th>
              <th>Dealer Email</th>
              <th>IMEI</th>
              <th>OTA Data</th>
              <th style="width: 100px; white-space: nowrap">Result</th>
            </tr>
          </thead>
          @if (dealersOtaList.length > 0) {
            <tbody>
              @for (
                item of dealersOtaList
                  | paginate
                    : {
                        id: 'batchpaginate',
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: totalItems,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.dealerName }}</td>
                  <td>{{ item.dealerEmail }}</td>
                  <td>{{ item.imei }}</td>
                  <td>{{ item.otaData }}</td>
                  <!-- <td>
                    <pre>{{ item.otaData | json }}</pre>
                  </td> -->
                  <td>{{ item.result }}</td>
                </tr>
              }
            </tbody>
          }
          @if (dealersOtaList.length === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <div class="component-footer">
        @if (dealersOtaList.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
